import React from 'react'
import styles from './AmbulanceItem.module.css'
import Button from '@material-ui/core/Button';


function AmbulanceItem({state,Ambulance}) {
    return (
        <div className={styles.component}>
                <div><h4 className={styles.stateName}>{state}</h4></div>
                
                <div>
                <a href={Ambulance} className={styles.link} target="_blank" rel="noreferrer">
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className={styles.viewButton}
                        >
                            View All Helplines
                    </Button> 
                </a>
                </div>
        </div>
    )
}

export default AmbulanceItem
